import React from 'react'
import { useTheme } from '@/context/ThemeContext'

interface MiniWavesProps {
  size?: string
  className?: string
}

const MiniWaves: React.FC<MiniWavesProps> = ({ size = 'h-8 w-8', className = '' }) => {
  const { isDarkMode } = useTheme()

  return (
    <div
      className={`relative overflow-hidden rounded-full ${isDarkMode ? 'bg-gray-800' : 'bg-white'} border border-[#E4E4E4] ${size} ${className} flex-shrink-0`}
    >
      <div className="absolute inset-0">
        <div className="relative w-full h-full">
          {/* Pink sound wave animations in the bottom half */}
          <div className="sound-wave-animation sound-wave-left pink-wave"></div>
          <div className="sound-wave-animation sound-wave-right pink-wave"></div>

          {/* Yellow sound wave animations with counter-posed timing and different animation */}
          <div className="sound-wave-animation yellow-wave-left yellow-wave yellow-rotated"></div>
          <div className="sound-wave-animation yellow-wave-right yellow-wave yellow-rotated"></div>
        </div>
      </div>
    </div>
  )
}

export default MiniWaves
